import { Radio, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import DownloadFileContainer from '../../DownloadFileContainer';
import { OPTIONS_LABEL } from '../../../utils/constants';

export default function UploadAndMCQView({ testDetails, submissionDetails, currentUser }) {
  return (
    <>
      {testDetails.type === 'upload' && submissionDetails?.submittedURL && (
        <DownloadFileContainer
          title={submissionDetails.submittedURL}
          fileLink={submissionDetails.submittedURL}
          isDownload
        />
      )}
      {/* If test has OMR */}
      {testDetails.type === 'upload' && submissionDetails?.questionsAndAnswers.length > 0 && (
        <>
          <Typography mb={1} fontSize={22} fontWeight="bold">
            {currentUser.profile === 'student' ? 'Your OMR Sheet' : 'Student Answers'}
          </Typography>
          <Table size="small" sx={{ mt: 2 }}>
            <TableHead>
              <TableRow>
                <TableCell />
                {new Array(testDetails.optionsPerQuestion).fill(0).map((_, i) => (
                  <TableCell align="center" key={i}>
                    {OPTIONS_LABEL[i]}
                  </TableCell>
                ))}
                <TableCell align="center">Correct Answer</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {submissionDetails?.questionsAndAnswers.map((qa, i) => (
                <TableRow key={qa._id}>
                  <TableCell>{i + 1}</TableCell>
                  {qa.options.map((qo) => (
                    <TableCell align="center" key={qo._id}>
                      <Radio checked={qo.isSelected} disabled />
                    </TableCell>
                  ))}
                  <TableCell align="center">
                    {OPTIONS_LABEL[qa.options.findIndex((op) => op.isAnswer === true)]}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </>
      )}
    </>
  );
}

UploadAndMCQView.propTypes = {
  testDetails: PropTypes.object,
  submissionDetails: PropTypes.object,
  currentUser: PropTypes.object
};
